(function () {
  'use strict';

  /* ========== CONFIG ========== */
  const dataEl = document.getElementById('bundle-product-page-data');
  if (!dataEl) return;

  const CONFIG  = JSON.parse(dataEl.textContent);
  const MAX_ITEMS = CONFIG.maxItems || 4;

  /* ========== STATE ========== */
  const STORAGE_KEY = 'mobilia_sample_pack';

  const state = {
    selections: loadSelections(),
  };

  function loadSelections() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length <= (CONFIG.maxItems || 4)) {
          return parsed;
        }
      }
    } catch (e) {}
    return [];
  }

  function saveSelections() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.selections));
    } catch (e) {}
  }

  function clearSelections() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  /* ========== DOM REFS (resolved inside init) ========== */
  let selectionBar, bundleCountEl, addToCartBtn;
  let inlineVariants, inlineAddBtn, inlineFeedback;

  let currentSelectedVariant = null;

  // The product page only ever has one product in CONFIG.products
  const product = CONFIG.products[0];

  /* ========== HELPERS ========== */
  function isVariantInPack(variantId) {
    return state.selections.some((s) => s.variantId === parseInt(variantId));
  }

  function getSelectionsForProduct(productId) {
    return state.selections.filter((s) => s.productId === parseInt(productId));
  }

  function showToast(message) {
    let toast = document.querySelector('.bundle-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bundle-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 2500);
  }

  /* ========== STICKY BAR RENDER ========== */
  function renderSlots() {
    const slots = selectionBar.querySelectorAll('.bundle-slot');

    slots.forEach((slot, index) => {
      const selection = state.selections[index];
      const emptyEl   = slot.querySelector('.bundle-slot__empty');
      const filledEl  = slot.querySelector('.bundle-slot__filled');

      if (selection) {
        slot.classList.add('is-filled');
        emptyEl.style.display  = 'none';
        filledEl.style.display = 'flex';

        filledEl.querySelector('.bundle-slot__image').src                = selection.image || '';
        filledEl.querySelector('.bundle-slot__image').alt                = selection.productTitle;
        filledEl.querySelector('.bundle-slot__product-name').textContent = selection.productTitle;
        filledEl.querySelector('.bundle-slot__variant-name').textContent = selection.variantTitle;

        slot.classList.remove('is-animating');
        void slot.offsetWidth;
        slot.classList.add('is-animating');
      } else {
        slot.classList.remove('is-filled', 'is-animating');
        emptyEl.style.display  = 'flex';
        filledEl.style.display = 'none';
      }
    });

    bundleCountEl.textContent = state.selections.length;
    addToCartBtn.disabled     = state.selections.length === 0;
  }

  /* ========== INLINE VARIANT PICKER ========== */
  function renderInlineVariants() {
    if (!product) return;

    inlineVariants.innerHTML  = '';
    currentSelectedVariant    = null;
    inlineAddBtn.disabled     = true;
    inlineFeedback.textContent = '';
    inlineFeedback.className  = 'bundle-modal__feedback bundle-inline__feedback';

    const packFull = state.selections.length >= MAX_ITEMS;

    if (packFull) {
      inlineFeedback.textContent = 'Your Sample Pack is full. Remove an item to add a new one.';
    }

    product.variants.forEach((variant) => {
      const alreadyAdded = isVariantInPack(variant.id);
      const btn          = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'bundle-variant-btn';

      if (!variant.available) btn.classList.add('is-unavailable');
      if (alreadyAdded)       btn.classList.add('is-already-added');

      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available || alreadyAdded || packFull;

      const swatchImage = variant.featured_image || product.featured_image;

      btn.innerHTML = `
        <div class="bundle-variant-btn__swatch">
          ${swatchImage ? `<img src="${swatchImage}" alt="${variant.option1}">` : ''}
        </div>
        <span class="bundle-variant-btn__name">${variant.option1}</span>
        <span class="bundle-variant-btn__check">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </span>
      `;

      if (variant.available && !alreadyAdded && !packFull) {
        btn.addEventListener('click', () => selectVariant(variant, btn));
      }

      inlineVariants.appendChild(btn);
    });
  }

  function selectVariant(variant, btnEl) {
    currentSelectedVariant = variant;

    inlineVariants.querySelectorAll('.bundle-variant-btn:not(.is-already-added)').forEach((b) => {
      b.classList.remove('is-selected');
    });
    btnEl.classList.add('is-selected');

    inlineAddBtn.disabled      = false;
    inlineFeedback.textContent = '';
  }

  function addFromInline() {
    if (!product || !currentSelectedVariant) return;

    if (state.selections.length >= MAX_ITEMS) {
      inlineFeedback.textContent = 'Your Sample Pack is full. Remove an item to add a new one.';
      inlineFeedback.className   = 'bundle-modal__feedback bundle-inline__feedback';
      return;
    }

    if (isVariantInPack(currentSelectedVariant.id)) {
      inlineFeedback.textContent = 'This variant is already in your Sample Pack.';
      inlineFeedback.className   = 'bundle-modal__feedback bundle-inline__feedback';
      return;
    }

    const image = currentSelectedVariant.featured_image || product.featured_image;

    state.selections.push({
      productId:    product.id,
      variantId:    currentSelectedVariant.id,
      productTitle: product.title,
      variantTitle: currentSelectedVariant.option1,
      sku:          currentSelectedVariant.sku || '',
      image,
    });

    saveSelections();
    renderSlots();
    renderInlineVariants();

    const remaining         = MAX_ITEMS - state.selections.length;
    const availableVariants = product.variants.filter((v) => v.available);
    const allAdded          = availableVariants.every((v) => isVariantInPack(v.id));

    if (allAdded || remaining === 0) {
      showToast(
        remaining === 0
          ? 'Sample Pack is full! Ready to add to cart.'
          : `${product.title} — all variants added.`
      );
    } else {
      inlineFeedback.textContent = `Added! ${remaining} sample${remaining === 1 ? '' : 's'} remaining.`;
      inlineFeedback.className   = 'bundle-modal__feedback bundle-inline__feedback bundle-modal__feedback--success';
    }
  }

  /* ========== REMOVE FROM PACK ========== */
  function removeFromPack(slotIndex) {
    if (state.selections[slotIndex]) {
      const removed = state.selections.splice(slotIndex, 1)[0];
      saveSelections();
      renderSlots();
      renderInlineVariants(); // refresh availability after removal
      showToast(`${removed.productTitle} — ${removed.variantTitle} removed from Sample Pack.`);
    }
  }

  /* ========== ADD TO CART ========== */
  async function addBundleToCart() {
    if (state.selections.length === 0) return;

    addToCartBtn.classList.add('is-loading');
    addToCartBtn.disabled = true;

    try {
      const productResponse = await fetch('/products/sample-pack.js');
      if (!productResponse.ok) throw new Error('Could not fetch Sample Pack product');

      const samplePackProduct   = await productResponse.json();
      const samplePackVariantId = samplePackProduct.variants[0].id;

      const properties = {};
      state.selections.forEach((selection, index) => {
        properties[`Sample ${index + 1}`]        = `${selection.productTitle} — ${selection.variantTitle}`;
        properties[`_sample_${index + 1}_sku`]   = selection.sku;
        properties[`_sample_${index + 1}_image`] = selection.image;
      });
      properties['_bundle_product_ids'] = state.selections.map((s) => s.variantId).join(',');

      const cartResponse = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          items: [{ id: samplePackVariantId, quantity: 1, properties }],
        }),
      });

      if (!cartResponse.ok) throw new Error('Failed to add to cart');

      showSuccessOverlay();
      state.selections = [];
      clearSelections();
      renderSlots();
      renderInlineVariants();

    } catch (error) {
      console.error('Bundle add to cart error:', error);
      showToast('Something went wrong. Please try again.');
    } finally {
      addToCartBtn.classList.remove('is-loading');
      addToCartBtn.disabled = state.selections.length === 0;
    }
  }

  /* ========== SUCCESS OVERLAY ========== */
  function showSuccessOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'bundle-success-overlay';
    overlay.innerHTML = `
      <div class="bundle-success-card">
        <div class="bundle-success-card__icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <h3 class="bundle-success-card__title">Sample Pack Added!</h3>
        <p class="bundle-success-card__text">Your free sample pack has been added to your cart.</p>
        <div class="bundle-success-card__actions">
          <a href="/cart" class="bundle-success-card__btn bundle-success-card__btn--primary">View Cart</a>
          <button type="button" class="bundle-success-card__btn bundle-success-card__btn--secondary" id="BundleSuccessContinue">Continue Browsing</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('is-visible'));

    overlay.querySelector('#BundleSuccessContinue').addEventListener('click', () => {
      overlay.classList.remove('is-visible');
      setTimeout(() => overlay.remove(), 300);
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('is-visible');
        setTimeout(() => overlay.remove(), 300);
      }
    });
  }

  /* ========== SCROLL EFFECT ========== */
  function handleScroll() {
    if (window.scrollY > 100) {
      selectionBar.classList.add('is-scrolled');
    } else {
      selectionBar.classList.remove('is-scrolled');
    }
  }

  /* ========== INIT ========== */
  function init() {
    selectionBar   = document.getElementById('BundleSelectionBar');
    bundleCountEl  = document.getElementById('BundleCount');
    addToCartBtn   = document.getElementById('BundleAddToCart');
    inlineVariants = document.getElementById('BundleInlineVariants');
    inlineAddBtn   = document.getElementById('BundleInlineAddBtn');
    inlineFeedback = document.getElementById('BundleInlineFeedback');

    if (!selectionBar || !inlineVariants) return false;

    // Slot remove buttons
    selectionBar.querySelectorAll('.bundle-slot__remove').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const slotIndex = parseInt(btn.closest('.bundle-slot').dataset.slot);
        removeFromPack(slotIndex);
      });
    });

    // Inline add button
    inlineAddBtn.addEventListener('click', addFromInline);

    // Add to cart
    addToCartBtn.addEventListener('click', addBundleToCart);

    // Scroll
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Initial render
    renderSlots();
    renderInlineVariants();

    return true;
  }

  /* ========== BOOT WITH RETRY ========== */
  function boot() {
    if (init() !== false) return;

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (init() !== false) {
        clearInterval(interval);
      } else if (attempts >= 20) {
        clearInterval(interval);
        console.warn('[BundleBuilder] Could not find required elements after 2s');
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();